<template>
  <div>
    <div class="text-center flex justify-center">
      <div class="text-center mt-4 w-10/12">
        <SidebarTitle icon="Edit3Icon" title="title" />
        <vs-input
          label=""
          v-model="routine.title"
          ref="titleInput"
          class="w-full focus:border-4 focus:border-solid"
          @keyup.enter.native.stop="save"
        />
       </div>
    </div>

    <ColorPicker v-model="routine.backgroundColor" class="mt-8"/>

    <RelatedAreas :key="`RelatedAreasRoutine-${editedEntity.id}`" class="mt-8 mb-8" v-model="routine.relatedAreas" />


    <slot></slot>

    <div class="mt-8 text-dark">
     <div v-if="!showFrequencyEdit" class="items-center">
        <div class="text-center flex justify-center">
          <SidebarTitle icon="RepeatIcon" title="repeat time"/>
        </div>
        <div class="flex justify-center items-center" :class="actionElementCss" @click.stop="showFrequencyEdit = true">
          <span class="font-smaller">
            <FrequencyInWords :routine="routine"/>
          </span>
          <feather-icon icon="EditIcon"  class="mx-2 w-4"  />
        </div>

      </div>
      <div v-if="showFrequencyEdit">
        <div class="text-center">

          <SidebarTitle icon="RepeatIcon" title="repeat time"/>
        </div>

       <div class="flex justify-center">
         <div class="mt-2">
            <vs-radio vs-name="daily" color="dark" class="mx-3" v-model="routine.frequency_period" vs-value="daily">daily</vs-radio>
            <vs-radio vs-name="weekly" color="dark" class="mx-3" v-model="routine.frequency_period" vs-value="week">weekly</vs-radio>
            <vs-radio vs-name="monthly" color="dark" class="mx-3" v-model="routine.frequency_period" vs-value="month">monthly</vs-radio>
         </div>
       </div>

         <div class="mt-4">

           <div v-if="weekly" class="text-center" >
            <div>
              <span class="font-smaller text-dark" v-if="routine.frequency_count == 1">
                repeat once a week
              </span>

              <span class="font-smaller text-dark" v-else>
                repeat {{routine.frequency_count}} days a week
              </span>
            </div>

              <vs-radio color="dark" class="mx-2" v-model="routine.frequency_count" vs-value="1" vs-name="weekly-1">1</vs-radio>
              <vs-radio color="dark" class="mx-2" v-model="routine.frequency_count" vs-value="2" vs-name="weekly-2">2</vs-radio>
              <vs-radio color="dark" class="mx-2" v-model="routine.frequency_count" vs-value="3" vs-name="weekly-3">3</vs-radio>
              <vs-radio color="dark" class="mx-2" v-model="routine.frequency_count" vs-value="4" vs-name="weekly-4">4</vs-radio>
              <vs-radio color="dark" class="mx-2" v-model="routine.frequency_count" vs-value="5" vs-name="weekly-5">5</vs-radio>
              <vs-radio color="dark" class="mx-2" v-model="routine.frequency_count" vs-value="6" vs-name="weekly-6">6</vs-radio>
            </div>

           <div v-if="monthly" class="text-center">
            <div>
              <span class="font-smaller text-dark" v-if="routine.frequency_count == 1">
                repeat once a month
              </span>

              <span class="font-smaller text-dark" v-else>
                repeat {{routine.frequency_count}} days a month
              </span>
            </div>

              <vs-radio color="dark" class="mx-2" v-model="routine.frequency_count" vs-value="1" vs-name="month-1">1</vs-radio>
              <vs-radio color="dark" class="mx-2" v-model="routine.frequency_count" vs-value="2" vs-name="month-2">2</vs-radio>
              <vs-radio color="dark" class="mx-2" v-model="routine.frequency_count" vs-value="3" vs-name="month-3">3</vs-radio>
            </div>
           </div>
        </div>


        <!-- Schedule  ================================================== -->

        <div class="mt-8 text-dark">
          <div v-if="!showScheduleEdit" class="items-center">
            <div class="text-center flex justify-center">
              <SidebarTitle icon="ClockIcon" title="schedule"/>
            </div>
            <div class="flex justify-center items-center" :class="actionElementCss" @click.stop="showScheduleEdit = true">
              <span class="font-smaller">
                {{schedule}}
              </span>
              <feather-icon icon="EditIcon"  class="mx-2 w-4"  />
            </div>
          </div>

          <div v-else>
            <div class="text-center">
              <div class="text-center">

                <SidebarTitle icon="ClockIcon" title="schedule" class="mt-8"/>
              </div>
              <div class="mt-2">
                <vs-radio color="dark" class="mx-2" v-model="routine.schedule" vs-value="" vs-name="schedule">anytime</vs-radio>
                <vs-radio color="dark" class="mx-2" v-model="routine.schedule" vs-value="morning" vs-name="schedule-morning">morning</vs-radio>
                <vs-radio color="dark" class="mx-2" v-model="routine.schedule" vs-value="afternoon" vs-name="schedule-afternoon">afternoon</vs-radio>
                <vs-radio color="dark" class="mx-2" v-model="routine.schedule" vs-value="nighttime" vs-name="schedule-nighttime">nighttime</vs-radio>
              </div>

            </div>
          </div>
        </div>
        <!-- END OF Schedule  ================================================== -->
      </div>

      <Editor v-model="routine.notes"/>

      <DiveDeeper>
        <DiveDeeperItem title="why is this important to me?" v-model="routine.whyDescription"/>

        <DiveDeeperItem title="what would I gain by achieving this?" v-model="routine.gainDescription"/>

        <DiveDeeperItem title="what are possible risks and obstacles?" v-model="routine.riskDescription"/>
      </DiveDeeper>

      <MakeIt title="make it stick">

         <DiveDeeperItem title="triggers" v-model="routine.makeIt.triggers" description="make it easy to start and obvious. Pick simple triggers that remind you of your routine (e.g. for exercise = yoga mat next to your bed)."/>
         <DiveDeeperItem title="rewards" v-model="routine.makeIt.rewards" description="make it attractive. Define rewards (benefits) that make your routine desirable, satisfying and worth repeating (e.g., exercise = short-term endorphins are released in the body, long-term you become a healthy and fit person.)."/>
         <DiveDeeperItem title="routine stacking" v-model="routine.makeIt.stacking" description="stack your routine. The best way to form a new routine is to tie it to an existing one. Complete by yourself: After/before [EXISTING ROUTINE] → I will perform [THIS ROUTINE]."/>

        </MakeIt>

      <InfoCard v-if="false" title="short-term & repetitive">
        <p class="mb-3">Routine ‑ the way you live your life. It is a behavioral pattern of behavior that can be developed through frequent repetition.</p>
        <p class="mb-3 font-bold">First, you make your habits. Then your habits make you.</p>

        <p class="italic">„We are what we repeatedly do. Excellence, then, is not an act, but a habit.“ — Will Durant</p>
      </InfoCard>

  </div>
</template>
<script>
import _ from 'lodash'
import { midnight } from '@/helpers/date'
import trackAnalytics from '@/helpers/trackAnalytics'
import ColorPicker from '@/views/Self-Improvee/Generic/ColorPicker'
import DiveDeeper from '@/views/Self-Improvee/Planner/DiveDeeper'
import DiveDeeperItem from '@/views/Self-Improvee/Planner/DiveDeeperItem'

export default {
  components: {
    ColorPicker,
    DiveDeeper,
    DiveDeeperItem
  },
  props: ['editedEntity'],
  watch: {
    'editedEntity': {
      immediate: true,
      async handler (editedEntity) {
        if (!editedEntity) return

        console.log('editedEntity', editedEntity)
        console.log('editedEntity.frequency_period', editedEntity.frequency_period)

        this.showFrequencyEdit = !this.edit
        this.showScheduleEdit = !this.edit
        this.routine = this.startingRoutine(editedEntity)
        if (!editedEntity.id && this.$store.getters.isLargeScreen) {
          this.$forceNextTick(() => this.$refs['titleInput'].focusInput())
          await this.$validator.resume()
        } else {
          await this.$validator.pause()
        }
      }
    },
    'routine.frequency_period': {
      immediate: false,
      handler (frequency_period) {
        if (frequency_period === 'month' && this.routine.frequency_count > 3) {
          this.routine.frequency_count = 3
        }
      }
    },
  },


  data () {
    return {
      routineDefaults: {
        title: '',
        datesRaw: '',
        startedOn: midnight(),
        frequency_count: 1,
        frequency_period: 'daily',
        backgroundColor: '',
        schedule: '',
        relatedAreas: [],
        whyDescription: '',
        gainDescription: '',
        riskDescription: '',
        notes: '',
        makeIt: { triggers: '', rewards: '', stacking: '' }
      },
      showFrequencyEdit: false,
      showScheduleEdit: false,
      routine: {},
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    },
    repeatInWords () {
      if (this.daily) {
        return 'repeat daily'
      } else {
        return `repeat ${this.routine.frequency_count} a ${this.routine.frequency_period}`
      }
    },
    edit () {
      return !!_.get(this.editedEntity, 'id')
    },
    weekly () {
      return this.routine.frequency_period === 'week'
    },
    daily () {
      return this.routine.frequency_period === 'daily'
    },
    monthly () {
      return this.routine.frequency_period === 'month'
    },
    schedule () {
      return this.routine.schedule || 'anytime'
    },
    nothingChanged () {
      console.log(JSON.stringify(this.routine), JSON.stringify(this.editedEntity))
      return JSON.stringify(this.routine) === JSON.stringify(this.editedEntity)
    },

  },
  methods: {
    startingRoutine (editedEntity) {
      return _.merge({}, this.routineDefaults, editedEntity)
    },
    save () {
      // if (!this.routine.title) {
      // this.$emit('saved')
      // return
      // }

      this.$validator.validateAll().then(async (result) => {
        if (!result) return

        if (this.edit) {
          const { title, frequency_count, frequency_period, backgroundColor, schedule, relatedAreas, whyDescription, gainDescription, riskDescription, makeIt, notes } = this.routine

          this.$store.dispatch('UPDATE_ROUTINE', { routine: this.editedEntity, updateFields: {title, frequency_count, frequency_period, backgroundColor, schedule, relatedAreas, whyDescription, gainDescription, riskDescription, makeIt, notes } })
        } else {
          const routine = { ...this.routineDefaults, ...this.routine }
          this.$store.dispatch('ADD_ROUTINE', { routine })
          trackAnalytics(this, 'app_action', 'routine', 'routine_add', this.$store.getters.daysFromRegistration)
        }

        // this.routine = this.routineDefaults
        this.$emit('saved')
      })

    },
    handleDelete () {
      this.$store.dispatch('DELETE_ROUTINE', { routine: this.editedEntity })
      this.$emit('saved')
    }
  },
  beforeDestroy () {
    this.$root.$off('routineSidebarFooterSaveClicked')
  },
  mounted () {
    console.log('mounting routineSidebarFooterSaveClicked')
    this.$root.$on('routineSidebarFooterSaveClicked', () => {
      console.log('$on(routineSidebarFooterSaveClicked')
      this.save()
    })
  },
}
</script>
<style>
</style>
